import React, { Component } from 'react'
import PropTypes from 'prop-types'
import withErrorBoundary from '../../../../components/hocs/withErrorBoundary'

export class UserProfileNameDisplay extends Component {
  static propTypes = {
    toggleNameForm: PropTypes.func.isRequired,
    user: PropTypes.any,
  }

  render() {
    const { user, toggleNameForm } = this.props
    return (
      <div>
        {user && <h3>{user.profile.name}</h3>}
        {user && <h4>{user.email}</h4>}
        <button
          id="editProfileBtn"
          onClick={() => toggleNameForm(true)}
          className="btn btn-primary"
        >
          Edit Profile
        </button>
      </div>
    )
  }
}

export default withErrorBoundary(UserProfileNameDisplay)



// WEBPACK FOOTER //
// ./src/routes/authenticated/UserProfile/components/UserProfileNameDisplay.js